import { useQuery } from "@tanstack/react-query"

import { trpcOptions } from "../trpc"

export const getClaimDataOptions = (sessionId: string) => trpcOptions.app.getClaimData.queryOptions({ sessionId })

export function useGetClaimData(sessionId: string) {
  return useQuery(getClaimDataOptions(sessionId))
}
